import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { AtxModalService } from './services';
import { AtxModalSimpleComponent, AtxModalBuilderComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
        NgbModalModule.forRoot(),
    ],
    declarations: [
        AtxModalSimpleComponent,
        AtxModalBuilderComponent
    ],
    entryComponents: [
        AtxModalSimpleComponent,
        AtxModalBuilderComponent
    ],
    providers: [
        AtxModalService
    ]
})

export class AtxModalModule {}
